import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
const checkoutUrl = 'https://checkout.ebookpoint.shop/cart/59787449761873:1';
type PurchaseButtonProps = {
  label?: string;
  className?: string;
};
export function PurchaseButton({
  label = 'Quiero recuperar mi bienestar',
  className = ''
}: PurchaseButtonProps) {
  return <a href={checkoutUrl} className={`group inline-flex min-h-14 w-full items-center justify-center gap-2 rounded-xl bg-[#b85f42] px-5 py-4 text-center text-sm font-bold text-white shadow-[0_8px_0_#88442f] transition hover:-translate-y-0.5 hover:bg-[#a85339] focus:outline-none focus-visible:ring-4 focus-visible:ring-[#b85f42]/35 ${className}`} data-id="element-36">
      {label}
      <ArrowRightIcon className="h-4 w-4 transition-transform group-hover:translate-x-0.5" aria-hidden="true" data-id="element-37" />
    </a>;
}